export const BreadcrumbTestIdFactory = {
    getBreadcrumbBase: () => 'breadcrumb',
    getBreadcrumbLinkBase: () => [BreadcrumbTestIdFactory.getBreadcrumbBase(), 'link'].join('-'),
    getBreadcrumbMenuButtonBase: () => [BreadcrumbTestIdFactory.getBreadcrumbBase(), 'menu'].join('-'),
    getBreadcrumbLoadingBase: () => [BreadcrumbTestIdFactory.getBreadcrumbBase(), 'loading'].join('-'),
    getBreadcrumbTestId: (testId) => [BreadcrumbTestIdFactory.getBreadcrumbBase(), testId].join('-'),
    getBreadcrumbLoadingTestId: (testId) => [BreadcrumbTestIdFactory.getBreadcrumbLoadingBase(), testId].join('-'),
    getBreadcrumbLinkTestId: (testId) => [BreadcrumbTestIdFactory.getBreadcrumbLinkBase(), testId].join('-'),
    getBreadcrumbMenuButtonTestId: (testId) => [BreadcrumbTestIdFactory.getBreadcrumbMenuButtonBase(), testId].join('-'),
    internalGenerateBreadcrumbLinkTestId: (testId, depth) => [testId, depth].join('-'),
};
